

import React from 'react'
import {ViewAllProjectsButtonContainer } from '../Flex/Flex.styled';
import { ViewAllProjectsButton } from '../Button/Button.styled'

const ViewAllProjects = () => {
  return (
     <ViewAllProjectsButtonContainer>
    <a href="/projects">
      <ViewAllProjectsButton>View All Projects</ViewAllProjectsButton>  
    </a>
     </ViewAllProjectsButtonContainer>
   
  );
}


export default ViewAllProjects 